import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController, AlertController, LoadingController, ActionSheetController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

import { Storage } from '@ionic/storage';

import { BusinessProductSubCategoryManagerHandler } from '../../providers/business-product-subcategory-handler';
import { BusinessProductSubcategoryModifierGroupListPage } from '../business-product-subcategory-modifier-group-list/business-product-subcategory-modifier-group-list';

import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-product-subcategory-manager',
  templateUrl: 'business-product-subcategory-manager.html',
})
export class BusinessProductSubcategoryManagerPage {
	subcategory: any;
	category: any;
	modifierGroups: any;
	private form : FormGroup;
	loader: any;
	filePath: any;
	isLoading: boolean = false;
	saveIsLoading: boolean = false;
	deleteIsLoading: boolean = false;

  	constructor(  		
  		private toastCtrl: ToastController,
		public navCtrl: NavController, 
		public viewCtrl: ViewController,
		public navParams: NavParams,
		private formBuilder: FormBuilder,
		public managerHandler: BusinessProductSubCategoryManagerHandler,
		public storage: Storage,
		public loadingCtrl: LoadingController,
		public alertCtrl: AlertController,
		public globals: Globals,
		public actionSheetCtrl: ActionSheetController,
		public _DomSanitizer: DomSanitizer
		) {

  		this.subcategory = navParams.data["subcategory"];
  		this.category = navParams.data["category"];
		
	    this.form = this.formBuilder.group({
	    	"Id": [''],
		  	"SubCategoryName":  ['', Validators.required],
		  	"CategoryId": [''],
		    "IsActive": [false],
	   	});   

	   	// this.form.controls.CategoryId = this.category.Id
  	}

  	ionViewWillEnter() {
		if(this.subcategory.Id){
	   		this.load(this.subcategory.Id);
	    } else {

	    	var categoryOption = {
	    		CategoryId: this.category.Id
	    	}

	    	this.form.patchValue(
				categoryOption
		    )
	    }
	}

	load(id){
		this.isLoading = true;

		this.managerHandler.getProductSubCategory(id, (result)=>{
		  	
		  	if(result.Id != ''){
		  		this.subcategory = result.subCategory;

		  		this.form.patchValue(
					this.subcategory
		    	)

		    	this.modifierGroups = result.modifierGroups;
		  	}

		  	this.isLoading = false;
		})
	}

	delete(){
		this.deleteIsLoading = true;
		
		this.managerHandler.delete(this.subcategory.Id, (result)=>{
			this.deleteIsLoading = true;

			if(result.Success)
				this.navCtrl.pop();
			else{
				let alert = this.alertCtrl.create({
	              title: 'Error',
	              subTitle: result.Message,
	              buttons: ['Ok']
	            });

	            alert.present();
			}
		});			
	}

	presentDeleteConfirmation() {
	  let alert = this.alertCtrl.create({
	    title: 'Confirm deletion',
	    message: 'Do you want to delete this subcategory?',
	    buttons: [
	      {
	        text: 'Delete',
	        handler: () => {
	          console.log('Delete clicked');
	          this.delete()
	        }
	      },
	      {
	        text: 'Cancel',
	        role: 'cancel',
	        handler: () => {
	          console.log('Cancel clicked');
	        }
	      }
	    ]
	  });
	  alert.present();
	}

	onSubmit(){
		if(this.saveIsLoading)
			return
		
		this.saveIsLoading = true;

		if(this.form.value.Id != ''){

			console.log("entered update");

			this.managerHandler.update(this.form.value.Id, this.form.value, (result)=>{
				if(result.Success){
					let toast = this.toastCtrl.create({
						message: 'Subcategory has been updated',
						duration: 3000,
						position: 'bottom'
					});

					toast.present();						
				} else {
					let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: result.Message,
				    	buttons: ['Ok']
				  	});
				  	
				  	alert.present();
				}

				this.saveIsLoading = false;
			})

		} else {
			console.log("entered create");

			this.managerHandler.create(this.form.value, (result)=>{
				if(result.Success){
					this.load(result.Data.Id);
				} else {
					let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: result.Message,
				    	buttons: ['Ok']
				  	});
				  	
				  	alert.present();
				}
			  				  	
				this.saveIsLoading = false;
			})
		}		  	
	}

	create(){
	    this.navCtrl.push(BusinessProductSubcategoryModifierGroupListPage, {
	      modifierGroup: {},
	      subcategory: this.subcategory
	    });		
	}

	manage($e, modifierGroup){
	    this.navCtrl.push(BusinessProductSubcategoryModifierGroupListPage, {
	      modifierGroup: modifierGroup,
	      subcategory: this.subcategory
	    });				
	}
}


// WEBPACK FOOTER //
// ./src/pages/business-product-subcategory-manager/business-product-subcategory-manager.ts